/* auto-generated: @mui/icons-material */
import Base from '@mui/icons-material/Warning';
import {withMuiAdapter} from '@common/icons/with-mui-adapter';

export const WarningIcon = withMuiAdapter(Base, 'Warning');
